import React, { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    SiriWave: any;
  }
}

interface SiriWaveProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  speed?: number;
  amplitude?: number;
  frequency?: number;
  color?: string;
  showWave: boolean;
}

export const SiriWave: React.FC<SiriWaveProps> = ({
  width = 640,
  height = 200,
  style,
  speed = 0.1,
  amplitude = 1,
  frequency = 6,
  color = "#fff",
  showWave = true,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const siriWaveRef = useRef<any>(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/siriwave/dist/siriwave.umd.min.js";
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (scriptLoaded && containerRef.current) {
      siriWaveRef.current = new window.SiriWave({
        container: containerRef.current,
        width,
        height,
        style: "ios9",
        speed,
        amplitude,
        frequency,
        color,
      });
      siriWaveRef.current.start();
    }

    return () => {
      if (siriWaveRef.current) {
        siriWaveRef.current.stop();
      }
    };
  }, [scriptLoaded, width, height, speed, amplitude, frequency, color, showWave]);

  if (showWave)
    return <div ref={containerRef} className={`w-${width} h-${height}`} style={style} />;

  return null;
};
